// Importing the global store hook for state management
import useGlobalStore from "../stores/globalStore";

// Creating a custom hook for navigation handling
export default function useNavigationHandler() {
  // Array of views representing different sections, needs to be same order as the Views in App.tsx
  const VIEWS = [
    "Kunduppgifter",
    "Fibernät",
    "Bredband",
    "Bredband - tillbehör",
    "Tv baspaket",
    "Tillvalspaket",
    "Flex kanaler",
    "Tv - tillbehör",
    "Säker med Teleservice",
    "Kunduppgifter",
  ];

  // Accessing state variables and update functions from the global store
  const { activeView, updateActiveView, selectedNetwork, selectedTvPackages } = useGlobalStore();

  // Function to handle navigation based on button clicks
  const navigationHandler = (btn: string) => {
    switch (btn) {
      case "next":
        if (activeView === 1 && selectedNetwork.id === 1111111) {
          // Go to NA-form if not sure which network to choose
          updateActiveView(activeView - 1);
        } else if (activeView === 3 && selectedNetwork.tv_kanal_paket.length === 1) {
          updateActiveView(activeView + 5);
        } else if (activeView === 5 && !selectedTvPackages.some((pack) => pack.title.includes("Flex"))) {
          // If has a tv package with "Flex" in its name, skip a step forward
          updateActiveView(activeView + 2);
        } else {
          // Normal next button
          updateActiveView(activeView + 1);
        }
        break;

      case "prev":
        if (activeView === 0) {
          // Back button for NA-form
          updateActiveView(activeView + 1);
        } else if (activeView === 8 && selectedNetwork.tv_kanal_paket.length === 1) {
          updateActiveView(activeView - 5);
        } else if (activeView === 7 && !selectedTvPackages.some((pack) => pack.title.includes("Flex"))) {
          // If has a tv package with "Flex" in its name, skip a step backward
          updateActiveView(activeView - 2);
        } else {
          // Normal back button
          updateActiveView(activeView - 1);
        }
        break;
      default:
        break;
    }
  };

  // Exposing variables and functions for external use
  return { navigationHandler, activeView, VIEWS };
}
